module.exports = "<div class=\"popup-modal\">\n    <div class=\"popup-header\">{{data.title}}</div>\n    <div class=\"popup-modal ng-scope\">\n        <div class=\"confirmation-window\">{{text}}</div>\n    </div>\n    <div class=\"popup-footer\">\n        <button class=\"btn btn-default\" [mat-dialog-close]=\"true\">Ok</button>\n        <button class=\"btn btn-default\" mat-dialog-close>Cancel</button>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component.html
// module id = 1906
// module chunks = 0